import styled from "styled-components";

export const TradeDaysContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 360px;
  overflow-y: auto;
  /* Left/top padding so the checkbox focus ring isn't clipped by the
     scroll container's overflow on the left edge. */
  padding: 4px 6px 4px 4px;

  scrollbar-width: thin;
  scrollbar-color: #c3c7cc #f2f3f5;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f2f3f5;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c3c7cc;
    border-radius: 10px;
  }

  .trade-day-item {
    display: flex;
    align-items: center;
    gap: 12px;

    .form-check-input {
      width: 16px;
      height: 16px;
      margin: 0;
      border: 1px solid #d5d7da;
      cursor: pointer;
      flex-shrink: 0;

      &:checked {
        background-color: #2258f1;
        border-color: #2258f1;
      }

      &:focus {
        border-color: #2258f1;
        box-shadow: 0 0 0 3px rgba(34, 88, 241, 0.18);
        outline: none;
      }
    }

    .trade-day {
      font-family: "Geist", sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: #414651;
      width: 96px;
      flex-shrink: 0;
    }

    .time-to {
      font-family: "Geist", sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #535862;
    }

    .react-time-picker {
      &__wrapper {
        border: 1px solid #e9eaeb;
        background: #ffffff;
        border-radius: 8px;
        padding: 6px 12px;
        font-size: 14px;
        font-family: "Geist", sans-serif;
        color: #414651;
      }

      &--disabled .react-time-picker__wrapper {
        background: #f5f5f5;
        opacity: 0.7;
      }

      /* Show the clear (×) cross, but without any button border/background.
         Uses !important to beat the global body button[disabled] rule that
         forces a white background and border on disabled buttons. */
      &__clear-button {
        border: none !important;
        background: none !important;
        box-shadow: none;
        outline: none;
        padding: 0;
      }

      &__button__icon {
        stroke: #535862;
        width: 13px;
      }
    }
  }

  @media screen and (max-width: 500px) {
    .trade-day-item {
      flex-wrap: wrap;
    }
  }
`;
